import PropTypes from 'prop-types';
import React from 'react';

function Logo(props) {
  const { fill, ...rest } = props;
  return (
    <svg height="24" style={{ fill }} viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M4 2.40002V13.7158L9.4823 21.6H15.8321L12.5056 13.7158H20V2.40002H4Z" fill={fill} />
    </svg>
  );
}
Logo.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string.isRequired
};
Logo.defaultProps = {
  color: 'white'
};
export default Logo;
